import React from "react";

interface Props {
  num: number;
  setNums: any;
}

function NumberButton({ num, setNums }: Props) {
  return (
    <button className="number-button" onClick={() => setNums((prev) => prev.filter((n) => n !== num))}>
      {num}
    </button>
  );
}

export default NumberButton;
